import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/apps/custom-made/src/app/configurator/loadingSkeleton.tsx");
